<template>
    <v-dialog
        v-model="isOpen"
        fullscreen
        hide-overlay
        transition="slide-x-reverse-transition"
    >
        <v-card>
            <v-toolbar flat>
                <v-btn
                    icon
                    @click="closeDialog"
                >
                    <v-icon>fas fa-arrow-left</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="py-1 px-1 d-flex flex-column justify-space-between">
                <standard-login-button
                    v-if="displayProfileFeatures"
                    data-testid="standard-login-button"
                />
                <menu-items />
                <v-row>
                    <v-col class="d-flex justify-center">
                        <a :href="getPortalLink()" class="logo-container">
                            <img :src="getLogoUrl" class="logo" alt="logo-clicsante-footer" />
                        </a>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import StandardLoginButton from '@/components/bars/profileButtons/profileButtons';
import menuItems from '@/components/bars/topHeaderMenu/MenuItems';
import { inferPortalUrl } from '@/helpers/env';

export default {
    name: 'dialog-menu',
    components: {
        StandardLoginButton,
        menuItems,
    },
    computed: {
        ...mapGetters({
            getIsOpen: 'mobileDialogMenu/getIsOpen',
            getAccessToken: 'jwt/getAccessToken',
            isClicSante: 'isClicSante',
            getLogoUrl: 'getLogoUrl',
        }),
        isOpen: {
            get: function() {
                return this.getIsOpen;
            },
            set: function(value) {
                this.setCloseMobileDialogMenu(value);
            },
        },
        displayProfileFeatures() {
            return this.isClicSante;
        },
    },
    methods: {
        ...mapMutations({
            setCloseMobileDialogMenu: 'mobileDialogMenu/SET_IS_OPEN',
        }),
        closeDialog() {
            this.setCloseMobileDialogMenu();
        },
        getPortalLink() {
            return inferPortalUrl();
        },
    },
};
</script>
<style lang="scss" scoped>
.logo {
    position: relative;
    width: 100%;
    max-width: 100px;
    min-width: 100px;
    filter: drop-shadow(0px 3px 6px #00000029);
}
</style>
